export default __webpack_public_path__ + "static/media/Ekso Bionics.f2a7cfa0.png";